import { FunctionalLocationNode, WorkOrderWithScore } from './functional-location-hierarchy-scores-propagation.utils';

export interface PriorityCounts {
  [priority: string]: number;
}

export class FunctionalLocationHierarchyPriorityCounter {
  

  public static processNode(node: FunctionalLocationNode): void {
    node.Children.forEach(child => this.processNode(child));

    const priorityCounts: PriorityCounts = {};

    this.countWorkOrderPriorities(node.ReleasedWorkOrders, priorityCounts);
    this.countWorkOrderPriorities(node.NotReleasedWorkOrders, priorityCounts);

    node.Children.forEach(child => {
      if ((child as any).PriorityCounts) {
        this.mergePriorityCounts(priorityCounts, (child as any).PriorityCounts);
      }
    });

    (node as any).PriorityCounts = priorityCounts;
  }

  private static countWorkOrderPriorities(workOrders: WorkOrderWithScore[], counts: PriorityCounts): void {
    workOrders.forEach(wo => {
      const priority = wo.WorkOrder.SAP_Priority;
      if (priority) {
        counts[priority] = (counts[priority] || 0) + 1;
      }
    });
  }

  private static mergePriorityCounts(target: PriorityCounts, source: PriorityCounts): void {
    Object.keys(source).forEach(priority => {
      target[priority] = (target[priority] || 0) + source[priority];
    });
  }
}
